"use client";

function Icon({ name, className = "", fill = false }: { name: string; className?: string; fill?: boolean }) {
  return <span className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}>{name}</span>;
}

const CHIPS = [
  { ar: "تعديل الحجز", en: "Edit booking" },
  { ar: "تسديد المبلغ", en: "Make a payment" },
  { ar: "التواصل مع المضيف", en: "Contact host" },
  { ar: "إلغاء الحجز", en: "Cancel booking" },
];

export default function HelpHero({
  isAr,
  search,
  onSearch,
}: {
  isAr: boolean;
  search: string;
  onSearch: (v: string) => void;
}) {
  const t = (a: string, e: string) => (isAr ? a : e);
  return (
    <section className="bg-clay-50 najdi-pattern">
      <div className="container mx-auto px-6 py-14 md:py-20 text-center">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-ink-900 mb-8">
          {t("كيف يمكننا مساعدتك؟", "How can we help?")}
        </h1>

        <div className="max-w-xl mx-auto relative">
          <span className="absolute top-1/2 -translate-y-1/2 inset-s-4 text-ink-500">
            <Icon name="search" />
          </span>
          <input
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder={t("ابحث في مركز المساعدة…", "Search the help center…")}
            className="w-full rounded-full bg-surface text-ink-900 ps-12 pe-4 py-4 outline-none shadow-sm border border-clay-100 focus:border-clay-600 placeholder:text-ink-500"
          />
        </div>

        {/* Quick chips */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-6">
          {CHIPS.map((c) => (
            <button
              key={c.ar}
              onClick={() => onSearch(t(c.ar, c.en))}
              className="rounded-full border border-clay-100 bg-surface px-4 py-2 text-sm font-medium text-ink-500 hover:text-clay-600 hover:border-clay-300 transition-colors"
            >
              {t(c.ar, c.en)}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
